import { fetchData } from '@/api/fetcher';
import { GetIngressUrlDocument } from '@/api/generated';
import type { GetIngressUrlQuery, GetIngressUrlQueryVariables } from '@/api/generated';

export const getIngressUrl = (input: GetIngressUrlQueryVariables['input']) =>
    fetchData<GetIngressUrlQuery, GetIngressUrlQueryVariables>(GetIngressUrlDocument, {
        input,
    })().then((data) => data.getIngressUrl);
